module.exports = __webpack_public_path__ + "static/media/3-passos.4b91845e.mp4";